var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingBagColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.2834 21C18.0942 21 18.9995 21 19.6678 20.6382C20.255 20.3204 20.7193 19.8157 20.9873 19.2042C21.2924 18.5082 21.2172 17.6059 21.0668 15.8014L20.3668 7.40138C20.2374 5.84875 20.1727 5.07243 19.8289 4.48486C19.5261 3.96744 19.0753 3.5526 18.5345 3.29385C17.9204 3 17.1414 3 15.5834 3L8.41665 3C6.85864 3 6.07963 3 5.46553 3.29384C4.92476 3.5526 4.47391 3.96744 4.17114 4.48486C3.82731 5.07243 3.76262 5.84875 3.63323 7.40138L2.93323 15.8014C2.78286 17.6059 2.70767 18.5082 3.0127 19.2042C3.2807 19.8157 3.74504 20.3204 4.3322 20.6382C5.00049 21 5.90588 21 7.71665 21H16.2834Z",
    stroke: "#FE6215",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 9.06087 15.5786 10.0783 14.8284 10.8284C14.0783 11.5786 13.0609 12 12 12C10.9391 12 9.92172 11.5786 9.17157 10.8284C8.42143 10.0783 8 9.06087 8 8",
    stroke: "#FE6215",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagColored);
export default __webpack_public_path__ + "static/media/ShoppingBagColored.d9f35e580201571688bfbba4ed0c5d9b.svg";
export { ForwardRef as ReactComponent };